import { connect } from 'react-redux';
import ItemCardsWrapper from './ItemCardsWrapper';

const mapStateToProps = ({ estimateBuilder }, ownProps) => {
  const { containers } = estimateBuilder.entities;
  const theContainer = containers.byId[ownProps.containerId];
  const { copyStyles } = estimateBuilder;
  return {
    itemIds: theContainer.items,
    copyStyles,
  };
};

export default connect(mapStateToProps)(ItemCardsWrapper);
